<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <table width='100%' class='mb-5'>
            <tr>
              <td class='text-left'>
                <v-btn icon large color='grey' @click='dayShift -= 1'>
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </td>
              <td class='text-center display-1' @click='dayShift = 0'>
                {{ currentDate | shortDate }}
              </td>
              <td class='text-right'>
                <v-btn icon large color='grey' @click='dayShift += 1'>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </td>
            </tr>
          </table>

          <wc-data-box
            :loading='isLoading'
            title='Log details'
            :titleIcon='$store.state.icons.snowTracker.icon'
            :titleIconColr='$store.state.icons.snowTracker.iconColor'
          >
            <div v-if='log'>
              <v-row no-gutters>
                <v-col class='display-3 pt-3 pl-3'>
                  {{ weatherData.text }}
                  <v-icon x-large :color='weatherData.color' class='display-2'>{{ weatherData.icon }}</v-icon>
                </v-col>
                <v-col cols='12' class='text-left pl-3'>
                  <div class='title grey--text font-weight-light'>{{ snowAmount }}</div>
                </v-col>
              </v-row>
              <v-card-text>
                <v-row no-gutters>
                  <v-col v-if='log && log.send_crews'>
                    Crews to bring:<br>
                    <ul>
                      <li v-if='log.bring_shovels'>Shovels</li>
                      <li v-if='log.bring_leaf_blowers'>Leaf blowers</li>
                      <li v-if='log.bring_snow_blowers'>Snow blowers</li>
                      <li v-if='log.bring_ice_scrapers'>Ice scrapers</li>
                      <li v-if='log.bring_ice_melt'>Rock Chip</li>
                    </ul>
                  </v-col>
                  <v-col :class="log && log.send_crews && log.routes_generated ? 'text-right' : ''">
                    <v-icon x-large :color='crewStatus.color'>{{ crewStatus.icon }}</v-icon><br>
                    {{ crewStatus.text }}
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
            <div v-else>
              <v-card-text class='title text-center'>
                No entry for this date
              </v-card-text>
            </div>
            <v-card-actions>
              <v-btn
                :color="log ? 'primary' : 'info'"
                :block="log ? false : true"
                depressed
                @click='showDialog = true'
                class='my-4'
              >
                <span v-if='log'>
                  Edit Details
                </span>
                <span v-else>
                  Setup the day
                </span>
              </v-btn>
              <v-spacer v-if='log'></v-spacer>
              <v-btn
                v-if='log && log.send_crews && !log.routes_generated'
                depressed
                color='success'
                :to="{ name: 'AssignRoutes', params: { stID: log.id } }"
              >
                Assign Routes
              </v-btn>
            </v-card-actions>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
    <log-dialog
      :showDialog='showDialog'
      :log='log'
      :date='currentDate'
      @cancel='showDialog = false'
      @save='save'
    ></log-dialog>
  </div>
</template>

<script>
import snowTrackerAPI from '../api/snowTracker'
import LogDialog from '../components/LogDialog'
import snowTrackerServices from '../services/snowTracker'
import moment from 'moment'

export default {
  name: 'schedule-dashboard',
  data: () => ({
    isLoading: true,
    showDialog: false,
    log: null,
    dayShift: 0
  }),
  computed: {
    currentDate () {
      return moment().add(this.dayShift, 'days').format('YYYY-MM-DD').toString()
    },
    weatherData () {
      return snowTrackerServices.getWeatherData(this.log)
    },
    snowAmount () {
      return snowTrackerServices.getSnowAmountText(this.log)
    },
    crewStatus () {
      return snowTrackerServices.getCrewStatus(this.log)
    }
  },
  watch: {
    dayShift () {
      this.getLog()
    }
  },
  mounted () {
    this.getLog()
  },
  methods: {
    async getLog () {
      this.isLoading = true
      let dt = moment().add(this.dayShift, 'days').format('YYYY-MM-DD').toString()
      this.log = await snowTrackerAPI.getSnowTrackerLogForDate(dt)
      this.isLoading = false
    },
    save (log) {
      this.log = log
      this.showDialog = false
    }
  },
  components: {
    'log-dialog': LogDialog
  }
}
</script>
